import { useMemo } from "react";
import { Typography } from "@mui/material";
import DOMPurify from "dompurify";
import { DropdownAnswer, DropdownBlankInstructor } from "@verity/api-client/types";
import pageStyles from "../QuizResultPanel.module.css";
import styles from "./QuestionAnswer.module.css";
import { AnswerStatusChip, AnswerViewProps, CorrectAnswerViewProps, parseBlankSegments, t } from "./shared";

export function DropdownAnswerView({ question, response }: AnswerViewProps) {
	const blanks = (question.options as DropdownBlankInstructor[] | undefined) ?? [];
	const userAnswers: DropdownAnswer = (response?.answer as DropdownAnswer) ?? {};
	const segments = useMemo(() => parseBlankSegments(question.questionText), [question.questionText]);
	const isAnswered = response?.isAnswered === true;

	return (
		<div className={styles.blankCard}>
			<div className={styles.blankInlineWrapper}>
				{segments.map((seg, i) => {
					if (seg.type === "html") {
						return <span key={i} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(seg.content) }} />;
					}
					const blank = blanks.find((b) => b.blankId === seg.blankId);
					const userText = (userAnswers[seg.blankId] ?? "").trim();
					const isCorrect = !userText
						? null
						: isAnswered && (blank?.options.some((o) => o.weightage > 0 && o.text === userText) ?? false);
					return <AnswerStatusChip key={i} userText={userText} isCorrect={isCorrect} />;
				})}
			</div>
		</div>
	);
}

export function DropdownCorrectAnswer({ question }: CorrectAnswerViewProps) {
	const blanks = (question.options as DropdownBlankInstructor[] | undefined) ?? [];
	if (blanks.length === 0) return null;
	const sorted = [...blanks].sort((a, b) => a.blankId - b.blankId);
	return (
		<div className={styles.correctAnswerSection}>
			<Typography className={pageStyles.sectionLabel}>{t("correctAnswer")}</Typography>
			<div className={styles.correctAnswerList}>
				{sorted.map((blank, i) => (
					<Typography key={blank.blankId} className={styles.correctAnswerItem}>
						<span className={styles.correctAnswerLabel}>{t("blankLabel", { n: i + 1 })}</span>{" "}
						{blank.options
							.filter((o) => o.weightage > 0)
							.map((o) => o.text)
							.join("/")}
					</Typography>
				))}
			</div>
		</div>
	);
}
